import { render, staticRenderFns } from "./ExpedientActionsComponent.vue?vue&type=template&id=5cd00948&scoped=true&lang=pug"
import script from "./ExpedientActionsComponent.vue?vue&type=script&lang=ts"
export * from "./ExpedientActionsComponent.vue?vue&type=script&lang=ts"
import style0 from "./ExpedientActionsComponent.vue?vue&type=style&index=0&id=5cd00948&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd00948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd00948')) {
      api.createRecord('5cd00948', component.options)
    } else {
      api.reload('5cd00948', component.options)
    }
    module.hot.accept("./ExpedientActionsComponent.vue?vue&type=template&id=5cd00948&scoped=true&lang=pug", function () {
      api.rerender('5cd00948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientActions/ExpedientActionsComponent.vue"
export default component.exports